/* eslint-disable camelcase */
import { esES_analyticTitle } from './analytic/title';
import { esES_globalTips } from './global/title';

const es_ES = {
  ...esES_globalTips,
  ...esES_analyticTitle,
};

export default es_ES;
